import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminValidationSettingsDataSourceService } from '../../services/admin-validation-settings-data-source.service';
import { AdminValidationSettingsFormData } from '../../models/admin-validation-settings-form-data';
import { AdminValidationSettingsFormComponent } from '../admin-validation-settings-form/admin-validation-settings-form.component';

@Component({
  selector: 'app-admin-validation-settings',
  imports: [
    CommonModule,
    AlertsComponent,
    SpinnerFilledComponent,
    AdminValidationSettingsFormComponent,
  ],
  templateUrl: './admin-validation-settings.component.html',
  styleUrl: './admin-validation-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminValidationSettingsComponent implements OnInit {
  private readonly validationSettingsDataSource = inject(
    AdminValidationSettingsDataSourceService,
  );
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  protected data$!: Observable<AdminValidationSettingsFormData>;

  public ngOnInit(): void {
    this.data$ = this.validationSettingsDataSource.fetchSettingsFormData();
  }

  public handleSubmitClick(data: AdminValidationSettingsFormData): void {
    this.validationSettingsDataSource
      .updateSettingsByFormData(data)
      .pipe(once())
      .subscribe({
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
